import { render, staticRenderFns } from "./VFatherProfessional.vue?vue&type=template&id=3a80f63d"
import script from "./VFatherProfessional.vue?vue&type=script&lang=js"
export * from "./VFatherProfessional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports